import { render } from "./ModalEvidencias.vue?vue&type=template&id=3a8a9c40&scoped=true"
import script from "./ModalEvidencias.vue?vue&type=script&lang=js"
export * from "./ModalEvidencias.vue?vue&type=script&lang=js"

import "./ModalEvidencias.vue?vue&type=style&index=0&id=3a8a9c40&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8a9c40"]])

export default __exports__